import script from "./content-home.vue?vue&type=script&setup=true&lang=js"
export * from "./content-home.vue?vue&type=script&setup=true&lang=js"

import "./content-home.vue?vue&type=style&index=0&id=1cbe6636&lang=scss"

const __exports__ = script;

export default __exports__